const createLookahead = term => `(?=.*${term}.*)`;
export function createSearchRegExp(searchTerm) {
  const expression = searchTerm.replace(/[^a-zA-Z\s]/g, '').split(/\s+/).map(createLookahead).join('');
  return new RegExp(expression, 'i');
}
export function hasSearchMatch(searchRegExp, ...values) {
  return searchRegExp.test(values.join(' '));
}
export const capitalize = value => value.replace(value[0], value[0].toUpperCase());